export enum LicenseActivationType {
  Pending,
  Active,
  Inactive,
  BillingFailed,
  Deactivated
}
